import type { ProjectListResponsePageAllOfThreeContentItemBasicInfoVisibility } from './projectListResponsePageAllOfThreeContentItemBasicInfoVisibility';

/**
 * 프로젝트 기본 정보
 */
export type ProjectListResponsePageAllOfThreeContentItemBasicInfo = {
  createdAt?: string;
  description?: string;
  /** 프로젝트 ID (Snowflake ID) */
  id?: number;
  title?: string;
  updatedAt?: string;
  visibility?: ProjectListResponsePageAllOfThreeContentItemBasicInfoVisibility;
};
